import { newList } from "@/apis/dict";
import { DictEnum, DictItem } from "@/types/dict"
import { useContext } from "react";
import { DictContext } from "../context/DictContext";
import { divided } from "@/utils/calc";


export const useMainCurrency = () => {
  const { exchangeRate, currencys } = useContext(DictContext);
  // 获取不到就resolve undefined，不报错
  const getMainCurrency = (supplierApi: string, dataList: DictItem[]) => {
    return new Promise<DictItem | undefined>((resolve) => {
      if (supplierApi) {
        newList(DictEnum.EXCHANGE_RATE, supplierApi)
          .then(res => {
            if (res && res.length > 0) {
              return resolve(res.find(dict => dict.desc === "mainCurrency"))
            } else return resolve(undefined)
          })
          .catch(() => resolve(undefined))
      } else {
        return resolve(dataList.find(dict => dict.desc === "mainCurrency"))
      }
    })
  };

  //A对B的汇率，eg：1 USD 等于多少 CNY ：getExchangeKey（USD，CNY）=> 6.7
  const getExchangeKey = (k1: string, k2: string) => {
    const c1 = exchangeRate.find(c => c.key === k1);
    const c2 = exchangeRate.find(c => c.key === k2);
    if (c1?.value && c2?.value) {
      return divided(c2.value, c1.value);
    }
    return '1';
  };

  const getExchangeVal = (cur1: string, cur2: string) => {
    const k1 = currencys.find(c => c.desc === cur1);
    const k2 = currencys.find(c => c.desc === cur2);
    if (k1 && k2) return getExchangeKey(k1.key, k2.key)
    else return '1';
  };

  return {
    getMainCurrency,
    getExchangeKey,
    getExchangeVal
  }
}